export default function Footer() {
  return (
    <>
      <div className="bg-dark-blue p-3 shadow-sm text-center">
        Copyright © Chronicle 2024
      </div>
    </>
  );
}
